import React from 'react'
import 'react-loading-skeleton/dist/skeleton.css'
import { useNavigate } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import styled from 'styled-components'

export const StyledAddButton = styled.span`
  float: right;
  button {
    border: 0;
    background: none;
    text-decoration: none;
    cursor: pointer;
    filter: ${({ disabled }: { disabled?: boolean }) => disabled && 'grayscale(75%)'};
  }

  i {
    cursor: pointer;
    margin-right: -2px;
    vertical-align: middle;
    color: ${props => !props.disabled && props.theme.highlightColor};
  }

  button:hover {
    color: ${props => !props.disabled && props.theme.highlightColor};
    animation: background 0.2s ease-in;
  }
`

export type ButtonProps = {
  label: string
  to?: string
  onClick?: () => void
  disabled?: boolean
  large?: boolean
  tooltip?: string
  showSpinner?: boolean
}
export const AddButton = ({ onClick, label, to, disabled, large, tooltip }: ButtonProps) => {
  const navigate = useNavigate()

  const onButtonClick = () => {
    if (!disabled) {
      if (!!to) {
        navigate(to)
      } else if (onClick) {
        onClick()
      }
    }
  }

  React.useEffect(() => {
    ReactTooltip.rebuild()
  }, [tooltip])

  return (
    <span onClick={onButtonClick}>
      <StyledAddButton disabled={disabled}>
        <i className="fas fa-plus-circle" />
        <button
          data-tip={tooltip}
          data-place="top"
          data-effect="solid"
        >
          {label}
        </button>
      </StyledAddButton>
    </span>
  )
}
